import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { FaFacebookF, FaInstagram, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import './Nosotros.css';
import Panel from '../assets/LOGOB.svg';
import LogoEsc from '../assets/logoV.svg';

const Nosotros = () => {

// 👉 AÑADIDO PARA ACTIVAR SCROLL SOLO AQUÍ
  useEffect(() => {
    document.body.classList.add("nosotros");
    document.documentElement.classList.add("nosotros");

    return () => {
      document.body.classList.remove("nosotros");
      document.documentElement.classList.remove("nosotros");
    };
  }, []);
  // 👉 FIN CAMBIO

  return (
    <section id="nosotros" className="nosotros-section">
      <Helmet>
        <title>Ipsum Ingeniería e Innovación</title>
        <meta charSet="UTF-8" />
        <meta name="description" content="Conoce a Ipsum Ingeniería..." />
      </Helmet>

      <div className="nosotros-background" />

      <div className="nosotros-overlay">
        
        {/* LOGO */}
        <img src={Panel} className="logoV" alt="Logo Ipsum" />

        {/* TEXTO */}
        <div className="nosotros-content">
          <p>
            <img src={LogoEsc} alt="Logo principal" className="logo-escritorio" />
            Somos una empresa que proporciona soluciones 
            <span className="highlight-n"> innovadoras y eficientes </span>
            en el campo de la ingeniería eléctrica y de las
            <span className="highlight-n"> energías renovables.</span>
         

          <p>
            A través del 
            <span className="highlight-n"> diseño, instalación, suministro, mantenimiento y asesoría </span>
            en sistemas eléctricos que garantizan seguridad, ahorro y sostenibilidad.
          </p> </p>
        </div>

        {/* BOTONES SOCIALES */}
        <div className="social-buttons">
          <a href="https://www.instagram.com/ipsum_2020"
             target="_blank" rel="noopener noreferrer"
             className="social-btn instagram">
            <FaInstagram /> Instagram
          </a>

          <a href="https://www.facebook.com/profile.php?id=61575908016731"
             target="_blank" rel="noopener noreferrer"
             className="social-btn facebook">
            <FaFacebookF /> Facebook
          </a>
        </div>

        {/* CONTACTO */}
        <div className="contact-info">
          <p><FaWhatsapp /> <a href="tel:+573174988280">3174988280 </a>
         <FaWhatsapp /> <a href="tel:+573024891161">3024891161 </a>
         <FaWhatsapp /> <a href="tel:+573142376242">3142376242</a></p>

          <p><FaEnvelope /> <a href="mailto:ipsumingenieriaeinnovacion@gmail.com">ipsumingenieriaeinnovacion@gmail.com</a></p>
          <p><FaEnvelope /> <a href="mailto:proyectos@ipsumiei.com">proyectos@ipsumiei.com</a></p>
        </div>

      </div>
    </section>
  );
};

export default Nosotros;
